import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { IoTrendingUpOutline } from 'react-icons/io5';
import './TrabajadorDashboardScreen.css';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import SafeAreaInsets from '../components/Shared/SafeAreaInsets';

function TrabajadorMetasScreen() {
  const { currentUser } = useAuth();
  const [metas, setMetas] = useState([]);

  useEffect(() => {
    if (!currentUser) return;

    const qMetas = query(
      collection(db, "trabajadores_metas"),
      where("trabajadorId", "==", currentUser.uid)
    );
    return onSnapshot(qMetas, (snap) => {
      const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setMetas(list);
    });
  }, [currentUser]);

  return (
    <div className="ks-page">
      <KondoSidebar activeRoute="/trabajador/metas" />

      <main className="ks-main">
        <SafeAreaInsets top={false} bottom={true} />
        <KondoBrandHeader showBack={false} />

        <div className="ks-scroll-area">
          <div className="muro-header-stitch">
            <div className="muro-hero-card">
              <div className="muro-hero-content">
                <h1>Objetivos y Metas</h1>
                <p>Mis metas de trabajo y bonos del periodo</p>
              </div>
              <IoTrendingUpOutline className="muro-hero-icon-decor" />
            </div>
          </div>

          <div style={{ padding: '16px' }}>
            <div className="trabajador-card-premium" style={{ maxWidth: '600px', margin: '20px auto' }}>
            <div className="card-section-title">
              <IoTrendingUpOutline size={24} style={{ color: '#7B61FF', marginRight: '8px' }} />
              <h3 style={{ fontSize: '1.25rem' }}>Mis Objetivos y Metas</h3>
            </div>

            {metas.length === 0 ? (
              <div className="dashboard-empty-state">
                <p>No tienes objetivos asignados en este periodo.</p>
              </div>
            ) : (
              <div className="goals-list">
                {metas.map(meta => (
                  <div key={meta.id} className="goal-card">
                    <div className="goal-header">
                      <strong>{meta.nombre}</strong>
                      <span className={`goal-status-badge ${meta.estado}`}>{meta.estado}</span>
                    </div>
                    <p>{meta.descripcion}</p>
                    {meta.bono && <span className="goal-bonus-label">Bono: ${meta.bono}</span>}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </main>

      <KondoBottomNav activeRoute="/trabajador/metas" />
    </div>
  );
}

export default TrabajadorMetasScreen;
